import { observer } from 'mobx-react'
import React from 'react'
import { Button, Header, Image, Modal, Form, Input, Label, Select } from 'semantic-ui-react'

import BuyCreditsModal from './buyCredits';

import AppModel from '../model/app'
import USER from '../model/user';

export default observer(function AssetStoreModal(props) {
  const [open, setOpen] = React.useState(typeof props.open !== 'undefined' ? props.open : false)

  return (
    <Modal
      onClose={() => { AppModel.setActiveAssetStoreItemInDetailMode(null); setOpen(false); props.onClose ? props.onClose() : null; }}
      onOpen={() => setOpen(true)}
      open={open}
      trigger={<Button color={ 'green' } onClick={ () => AppModel.retrieveAssetStoreLibrary() }>{ props.componentInEditMode ? 'Asset Store' : 'Asset Store' }</Button>}
    >
      <Modal.Header style={{ display: 'flex', justifyContent: 'space-between' }}>
          Asset Store
          <div style={{ position: 'absolute', top: 12, right: 20, fontSize: 13 }}><span style={{ marginRight: 10 }}>{ USER.credits } credits available</span> <BuyCreditsModal /></div>
      </Modal.Header>
      <Modal.Content scrolling>
        <Modal.Description>
            <div className='media-list-container' style={ AppModel.getActiveAssetStoreItemDetails() ? { paddingRight: '300px', minHeight: 450 } : { minHeight: 450 } }>
                <Form style={{ marginBottom: 50 }}>
                    <Form.Field>
                        <label>
                            <Input type="text" placeholder='Search...' />
                        </label>
                    </Form.Field>
                    <Form.Field>
                        <Select placeholder='Filter results' options={[
                            { key: 'all', value: 'all', text: 'All Media Types' },
                            { key: 'image', value: 'image', text: 'Images only' },
                            { key: 'video', value: 'video', text: 'Videos only' },
                            { key: 'templates', value: 'templates', text: 'Templates only' },
                        ]} defaultValue={ `all` } onChange={ (e, data) => {  } } />
                    </Form.Field>
                </Form>
                
                <div className='media-list' style={{ overflowX: 'hidden', overflowY: 'scroll' }}>
                    { AppModel.getAssetStoreList() }
                </div>
                
                {
                    AppModel.getActiveAssetStoreItemDetails() ? 
                        <div className='media-list-details'>
                            <div className='media-list-details-image'>
                                {
                                    AppModel.getActiveAssetStoreItemDetails().type === 'video/mp4' ? <video src={`${AppModel.getActiveAssetStoreItemDetails().location}`} autoPlay={false} muted loop={true} playsinline controls width="100%" height="100%" /> : null
                                }
                                {
                                    AppModel.getActiveAssetStoreItemDetails().type === 'image/jpeg' || AppModel.getActiveAssetStoreItemDetails().type === 'image/png' || AppModel.getActiveAssetStoreItemDetails().type === 'image/gif' || AppModel.getActiveAssetStoreItemDetails().type === 'image/bmp' || AppModel.getActiveAssetStoreItemDetails().type === 'image/svg+xml' ? <img src={ AppModel.getActiveAssetStoreItemDetails().location } style={{ width: '100%', height: 'auto' }} /> : null
                                }
                            </div>
                        
                            <Form.Field>
                                <label>
                                    <Label>Label</Label>
                                    <Input disabled type="text" value={ AppModel.getActiveAssetStoreItemDetails().label } />
                                </label>
                            </Form.Field>
                            <Form.Field>
                                <label>
                                    <Label>Date</Label>
                                    <Input disabled type="text" value={ new Date(parseFloat(AppModel.getActiveAssetStoreItemDetails().date)) } />
                                </label>
                            </Form.Field>
                            <Form.Field>
                                <label>
                                    <Label>Type</Label>
                                    <Input disabled type="text" value={ AppModel.getActiveAssetStoreItemDetails().type } />
                                </label>
                            </Form.Field>

                            <div style={{ marginTop: 20 }}>
                                <Button color='green' size='mini' onClick={() => AppModel.buyAssetStoreItem(AppModel.getActiveAssetStoreItemDetails().id) }>Buy for 2 credits</Button>
                            </div>
                        </div>
                    : null
                }
            </div>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions style={{ display: 'flex', justifyContent: 'space-between' }}>
        {
            props.componentInEditMode ? 
            <Button color='white' onClick={() => { AppModel.setActiveAssetStoreItemInDetailMode(null); setOpen(false); props.onClose ? props.onClose() : null; }}>
                Go Back
            </Button>
            : 
            <Button color='white' onClick={() => { AppModel.setActiveAssetStoreItemInDetailMode(null); setOpen(false); props.onClose ? props.onClose() : null; }}>
                Close
            </Button>
        }

        {
            props.componentInEditMode ? 
            <Button color='green' onClick={() => { 
                if (props.attribute === 'source') {
                    AppModel.current_screen.updateComponentAttribute(AppModel.current_screen.component_in_edit_mode, 'source', AppModel.getActiveAssetStoreItemDetails().id);
                } else if (props.attribute === 'backgroundImage') {
                    AppModel.current_screen.updateComponentStyleAttribute(AppModel.current_screen.component_in_edit_mode, 'backgroundImage', AppModel.getActiveAssetStoreItemDetails().id)
                } else if (props.attribute === 'menu_icon') {
                    AppModel.menu.updateMenuTabIcon(AppModel.getActiveAssetStoreItemDetails().id)
                } else if (props.attribute === 'menu_icon_close') {
                    AppModel.menu.updateMenuTabCloseIcon(AppModel.getActiveAssetStoreItemDetails().id)
                } else if (props.attribute === 'push_notification_image') {
                    AppModel.updatePushNotificationAttribute('image', AppModel.getActiveAssetStoreItemDetails().id)
                }
                setOpen(false)
                props.onClose ? props.onClose() : null;
            }}>
                Use this asset
            </Button>
            : 
            null
        }

      </Modal.Actions>
    </Modal>
  )
})